import { prefersReducedMotion } from '@vp/swan';

const AdaptiveCarouselTrackTestId = 'adaptive-carousel-track';

export const scrollGalleryToTargetSlide = (
  carouselElement: HTMLElement | null,
  slideNumber: number
): void => {
  const track = carouselElement?.querySelector<HTMLElement>(
    `[data-testid="${AdaptiveCarouselTrackTestId}"]`
  );
  const targetSlide = track?.children[slideNumber - 1] as HTMLElement | undefined;

  if (track && targetSlide && typeof track.scrollTo === 'function') {
    track.scrollTo({
      left: targetSlide.offsetLeft,
      behavior: prefersReducedMotion() ? 'instant' : 'smooth',
    });
  }
};
